const Pencil = ({
  width = '14px',
  height = '14px',
  fillColor = 'none',
  strokeColor = 'currentColor'    
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fillColor}
      stroke={strokeColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 14.3334L5.36602 12.9105C5.60264 12.8195 5.72096 12.774 5.83165 12.7146C5.92997 12.6618 6.0237 12.6009 6.11186 12.5324C6.21112 12.4554 6.30075 12.3658 6.48002 12.1865L13.9999 4.66671C14.7362 3.93033 14.7362 2.73642 13.9999 2.00004C13.2635 1.26366 12.0696 1.26366 11.3332 2.00004L3.81336 9.51985C3.63409 9.69912 3.54445 9.78876 3.46743 9.88801C3.39902 9.97617 3.33811 10.0699 3.28533 10.1682C3.22591 10.2789 3.1804 10.3972 3.08939 10.6339L1.6665 14.3334ZM1.6665 14.3334L3.03858 10.766C3.13677 10.5107 3.18586 10.3831 3.27006 10.3246C3.34365 10.2735 3.43471 10.2542 3.5227 10.271C3.62339 10.2902 3.72009 10.3869 3.91349 10.5803L5.41955 12.0864C5.61295 12.2798 5.70965 12.3765 5.72888 12.4772C5.74568 12.5652 5.72636 12.6562 5.67527 12.7298C5.6168 12.814 5.48916 12.8631 5.23388 12.9613L1.6665 14.3334Z"
        stroke={strokeColor || null}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Pencil;
